import { render, staticRenderFns } from "./SelectBoxWithOptionalInput.vue?vue&type=template&id=bb31c572&scoped=true"
import script from "./SelectBoxWithOptionalInput.vue?vue&type=script&lang=ts"
export * from "./SelectBoxWithOptionalInput.vue?vue&type=script&lang=ts"
import style0 from "./SelectBoxWithOptionalInput.vue?vue&type=style&index=0&id=bb31c572&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb31c572",
  null
  
)

export default component.exports